import React, { useRef, useState } from 'react';
import { Desktop, Mobile } from '../../../App';
import { USDT, formatUSDNoDecimals } from '../../../helpers/helperFunctions';
import { CaptionText, H3, H4, P2, P3 } from '../../../styles/FontStyles';
import { ArrowChevron, Flexed } from '../../../styles/GlobalComponents';
import { color, colors } from '../../../styles/GlobalStyles';
import { Collapsable, HubArrow, HubImage, HubStyled } from './Hub.styled';
import { useTranslation } from 'react-i18next';

export const Hub = ({
  id,
  image,
  title,
  price,
  priceToShow,
  packagePrice,
  selectedLicence,
  button,
  weeklyCap,
  info,
  limitedQuantity,
  dobuleTradingBinaries,
  willyMemeCoins,
  stakingHubDetails,
  condensed,
  onClick,
  selected,
  currency,
  includesSubscription,
  isMemeBonusActivated,
  subtitle,
  tickets,
  subscriptionPrice,
  showTickets
}: any) => {
  const { t } = useTranslation('marketplace');

  const [expanded, setExpanded] = useState(false);

  const ref = useRef<any>(null);
  const elementHeight = ref?.current?.clientHeight;

  const wide = window.innerWidth > 800;

  const showSubtitleText = () => {
    if (subtitle !== null && subtitle !== undefined) {
      return (
        <>
          <Desktop>
            {showTickets ? (
              <>
                <P3 bold right caps>
                  {subtitle} <span>{tickets}</span>
                </P3>
              </>
            ) : (
              <>
                <P3 bold right caps>
                  {title === 'Bronze' || title === 'Gold' || title === 'Silver'
                    ? ''
                    : subtitle}
                </P3>
                <P3 bold caps right color={colors.secondary100}>
                  {tickets === '+null ticket' ? '' : tickets}
                </P3>
              </>
            )}
          </Desktop>
          <Mobile>
            <Flexed between>
              <P3 bold right caps>
                {title === 'Gold' || title === 'Silver' ? '' : subtitle}
              </P3>
              <P3 bold caps right color={colors.secondary100}>
                {tickets === '+null ticket' ? '' : tickets}
              </P3>
            </Flexed>
          </Mobile>
        </>
      );
    } else if (willyMemeCoins !== null && willyMemeCoins !== undefined) {
      return (
        <>
          <Desktop>
            <P3 bold right caps>
              willy meme coins
            </P3>
            <P3 bold caps right color={colors.secondary100}>
              +{formatUSDNoDecimals(willyMemeCoins)} per day*
            </P3>
          </Desktop>
          <Mobile>
            <Flexed between>
              <P3 bold right caps>
                willy meme coins
              </P3>
              <P3 bold caps right color={colors.secondary100}>
                +{formatUSDNoDecimals(willyMemeCoins)} per day*
              </P3>
            </Flexed>
          </Mobile>
        </>
      );
    }
  };
  return (
    <HubStyled
      condensed={condensed}
      selected={selected}
      onClick={wide ? onClick : null}
      includesSubscription={includesSubscription}>
      <div>
        <HubImage
          condensed={condensed}
          onClick={() => setExpanded(!expanded)}
          image={image}
        />
        <div>
          <Flexed column between>
            <div>
              <Desktop>
                <H3 color={selected ? colors.primary900 : ''} mb='4'>
                  {title}
                </H3>
              </Desktop>
              <Mobile>
                <H4
                  color={expanded ? colors.primary900 : ''}
                  onClick={() => setExpanded(!expanded)}
                  mb='4'
                  mr='20'>
                  {title}
                </H4>
              </Mobile>

              <Desktop>
                {priceToShow ? (
                  <P2 mb='12' color={colors.neutral500}>
                    {priceToShow}
                  </P2>
                ) : subscriptionPrice ? (
                  <>
                    <P2 color={colors.neutral500}>
                      {formatUSDNoDecimals(price)} {currency || USDT} Membership
                    </P2>
                    <P2 color={colors.neutral500}>
                      {formatUSDNoDecimals(subscriptionPrice)}{' '}
                      {currency || USDT} Subscription
                    </P2>
                    {selectedLicence && (
                      <P2 color={colors.neutral500}>
                        {formatUSDNoDecimals(selectedLicence.price)}{' '}
                        {currency || USDT} BO subscription
                      </P2>
                    )}
                  </>
                ) : (
                  <P2 mb='12' color={colors.neutral500}>
                    {formatUSDNoDecimals(price)} {currency || USDT}{' '}
                    {`${(id > 220 && id < 225) || id === 1 ? 'yearly' : ''} `}
                  </P2>
                )}

                {isMemeBonusActivated && (
                  <P2 mb='12' bold color={colors.primary900}>
                    This voucher will generate{' '}
                    {formatUSDNoDecimals(packagePrice)}
                    <br /> Willy Meme Coins per day
                  </P2>
                )}
              </Desktop>

              <Mobile>
                <P3
                  onClick={() => setExpanded(!expanded)}
                  mb='12'
                  color={colors.neutral500}>
                  {priceToShow ? (
                    <P2 mb='12' color={colors.neutral500}>
                      {priceToShow}
                    </P2>
                  ) : subscriptionPrice ? (
                    <>
                      <P2 color={colors.neutral500}>
                        {formatUSDNoDecimals(price)} {currency || USDT}{' '}
                        Membership
                      </P2>
                      <P2 color={colors.neutral500}>
                        {formatUSDNoDecimals(subscriptionPrice)}{' '}
                        {currency || USDT} Subscription
                      </P2>
                      {selectedLicence && (
                        <P2 color={colors.neutral500}>
                          {formatUSDNoDecimals(selectedLicence.price)}{' '}
                          {currency || USDT} BO subscription
                        </P2>
                      )}
                    </>
                  ) : (
                    <P2 mb='12' color={colors.neutral500}>
                      {formatUSDNoDecimals(price)} {currency || USDT}{' '}
                      {`${id > 220 && id < 225 ? 'yearly' : ''} `}
                    </P2>
                  )}
                </P3>
              </Mobile>
            </div>
            {button}
            <Mobile>
              {includesSubscription && (
                <CaptionText bold right mb='4' color={colors.primary900}>
                  {t('includes_number_year', {
                    years: includesSubscription
                  })}
                </CaptionText>
              )}
            </Mobile>

            <HubArrow onClick={() => setExpanded(!expanded)}>
              <ArrowChevron direction={expanded ? 'up' : 'down'} />
            </HubArrow>
          </Flexed>
          <Flexed column between>
            <Flexed column>
              {weeklyCap && (
                <>
                  <P3 bold right>
                    {t('binary_weekly_cap')}
                  </P3>
                  <P3 bold right color={colors.secondary100}>
                    {weeklyCap}
                  </P3>
                </>
              )}

              <P3 bold right color={colors.secondary100}>
                {limitedQuantity && t('limited_quantity')}
              </P3>

              {showSubtitleText()}
            </Flexed>
            {info}
            <Desktop>
              {includesSubscription && (
                <CaptionText bold right mb='4' color={colors.primary900}>
                  {showTickets ? (
                    <>
                      {' '}
                      Includes {includesSubscription}-
                      {includesSubscription === 1 ? 'YEAR' : 'YEARS'} <br />
                      Back-Office
                      <br /> Subscription
                    </>
                  ) : (
                    <>
                      Includes {includesSubscription}-
                      {includesSubscription === 1 ? 'Year' : 'Years'} <br />{' '}
                      Back-Office Subscription
                    </>
                  )}
                </CaptionText>
              )}
            </Desktop>
          </Flexed>
        </div>
      </div>
      <Collapsable expanded={expanded} elementHeight={elementHeight}>
        <Flexed
          column
          gap='16px'
          onClick={() => setExpanded(!expanded)}
          ref={ref}
          style={{ padding: 16 }}>
          {weeklyCap && (
            <P3 bold>
              {t('binary_weekly_cap')}{' '}
              <span style={{ color: colors.secondary100 }}>{weeklyCap}</span>
            </P3>
          )}
          {limitedQuantity && (
            <P3 bold color={colors.secondary100}>
              {limitedQuantity && t('limited_quantity')}
            </P3>
          )}

          {showSubtitleText()}

          {stakingHubDetails}
        </Flexed>
      </Collapsable>
    </HubStyled>
  );
};
